import { render, staticRenderFns } from "./ExportHistoryTable.vue?vue&type=template&id=67402f38&"
import script from "./ExportHistoryTable.vue?vue&type=script&lang=ts&"
export * from "./ExportHistoryTable.vue?vue&type=script&lang=ts&"
import style0 from "./ExportHistoryTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports